export default function shiftLeft(arr) {
  let first = arr.shift();
  arr.push(first);
  return arr;
}
